import { memo } from "react";

import { PlainMessageBody } from "./PlainMessageBody";
import { TipTapMessageBody } from "./TipTapMessageBody";

export interface ContentBodyProps {
  message: any;
  shouldScrollIntoView?: boolean;
  shouldScrollToMessage?: boolean;
  shouldShowPreviewBlocks?: boolean;
}

export const ContentBody = memo(
  ({
    message,
    shouldScrollIntoView = false,
    shouldShowPreviewBlocks = true,
    shouldScrollToMessage = false,
  }: ContentBodyProps) => {
    if (message.rich_text_body) {
      return (
        <TipTapMessageBody
          rich_text_body={message.rich_text_body}
          shouldScrollIntoView={shouldScrollIntoView}
          editedAt={message.edited_at}
          chatRoomAccessArr={message.embedded_chat_message_access}
          shouldShowPreviewBlocks={shouldShowPreviewBlocks}
          chatProps={{
            unfurlUrls: message.unfurl_urls,
            shouldScrollToMessage,
          }}
        />
      );
    }
    return <PlainMessageBody body={message.body} />;
  },
);

ContentBody.displayName = "ContentBody";
